import SyncableModel from './SyncableModel';

export default class CycleToDo extends SyncableModel {
  static name = 'CycleToDo'

  _fillable = [
    'id',
    'cycle_id',
    'logged_at',
    'state',
    "created_by", "updated_by",
    "created_at", "updated_at",
  ]

  incrementing = false

  static syncOnly = true

  static hasSyncedAt = false

  _casts = {
    state: "object",
  }

  static endpoint = '/cycle_to_dos'

  static online = true
}
